import { Clock, User, Camera } from "@phosphor-icons/react";
import { TYPE_MAP } from "./equipmentTypes";
import { patientIssue } from "./PatientIssueBlock";

const daysSince = (iso) => (iso ? Math.floor((Date.now() - new Date(iso).getTime()) / 86400000) : null);

// Tarjeta compacta del Hospital Interno: código, qué equipo es, una línea del problema y quién lo tiene.
export default function PatientCard({ patient: p, onOpen, dragRef, onDragEnd }) {
  const days = daysSince(p.received_at);
  const labels = p.labels || [];
  const issue = patientIssue(p);
  const type = p.equipment_type && p.equipment_type !== "laptop" ? (TYPE_MAP[p.equipment_type]?.label || p.equipment_type) : null;
  return (
    <div
      draggable
      onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; dragRef.current = p.id; }}
      onDragEnd={onDragEnd}
      onClick={() => onOpen(p)}
      className="group bg-white border border-zinc-200 rounded-md p-3 cursor-grab active:cursor-grabbing hover:border-[#002FA7] hover:shadow-md transition-[border-color,box-shadow]"
      data-testid={`patient-card-${p.id}`}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="flex items-center gap-1.5 min-w-0">
          <span className="font-mono text-[10px] font-bold text-[#002FA7] shrink-0" data-testid={`patient-code-${p.id}`}>{p.code}</span>
          {type && <span className="text-[9px] uppercase tracking-wider font-semibold text-zinc-500 bg-zinc-100 px-1.5 py-px rounded-sm truncate">{type}</span>}
        </span>
        {days !== null && (
          <span className={`inline-flex items-center gap-1 text-[10px] font-mono-data shrink-0 ${days > 30 ? "text-[#E0000F]" : days > 14 ? "text-amber-600" : "text-zinc-400"}`} title={`${days} días desde su recepción`}><Clock size={10} /> {days}d</span>
        )}
      </div>
      <div className="font-semibold text-sm text-zinc-900 leading-snug mt-1.5 line-clamp-1" title={`${p.brand || ""} ${p.model || ""}`} data-testid={`patient-name-${p.id}`}>{p.brand} {p.model}</div>
      {issue && (
        <p className="text-xs text-zinc-500 mt-0.5 line-clamp-1 group-hover:text-zinc-700 transition-colors" title={issue} data-testid={`patient-issue-${p.id}`}>{issue}</p>
      )}
      <div className="mt-2.5 flex items-center justify-between gap-2 text-[11px]">
        <span className={`inline-flex items-center gap-1 min-w-0 truncate ${p.technician_name ? "text-zinc-700" : "text-zinc-400 italic"}`} data-testid={`patient-tech-${p.id}`}>
          <User size={11} /> {p.technician_name || "Sin asignar"}
        </span>
        <span className="flex items-center gap-1 shrink-0">
          {labels.slice(0, 2).map((lb, i) => (
            <span key={i} className="text-[9px] font-semibold px-1.5 py-px rounded-sm max-w-[90px] truncate" style={{ background: `${lb.color || "#52525B"}1f`, color: lb.color || "#52525B" }} title={lb.text}>{lb.text}</span>
          ))}
          {labels.length > 2 && <span className="text-[9px] text-zinc-400" title={labels.slice(2).map((l) => l.text).join(", ")}>+{labels.length - 2}</span>}
          {(p.photos || []).length > 0 && <span className="inline-flex items-center gap-0.5 text-[10px] font-mono-data text-zinc-400" title={`${p.photos.length} foto(s)`}><Camera size={10} weight="bold" /> {p.photos.length}</span>}
        </span>
      </div>
    </div>
  );
}
